var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['dropdown-menu', { icons: _vm.icons, touch: _vm.touch, dense: _vm.dense, open: _vm.open, 'dropdown-block': _vm.dropdownBlock }]},[_c('div',{staticClass:"menu"},[_vm._t("menu")],2),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }